/* eslint-disable */
import { DatePicker } from "@mui/x-date-pickers";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import { getOrdenesEnvio } from "../../../project/services/OrdenEnvioService";
import RecepcionOrdenEnvioDialog from "./RecepcionOrdenEnvioDialog";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
  codigoOrdenEnvio: "",
  codigoGestionAtencion: "",
  sucursalGenera: "",
  sucursalEnvia: "",
  usuario: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  fechaEstadoDesde: null,
  fechaEstadoHasta: null,
  estadoActual: "enviado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todas",
  },
  {
    id: "preparando",
    descripcion: "Preparando",
  },
  {
    id: "enviado",
    descripcion: "Por recibir",
  },
  {
    id: "recibido",
    descripcion: "Recibidas",
  },
];

const nameItemsText = "Recepción de Ordenes de Envío";
//
// ################################################################################
//
const RecepcionOrdenEnvioTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [ordenesEnvio, setOrdenesEnvio] = useState([]);
  const [areas, setAreas] = useState([]);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [idOrdenEnvio, setIdOrdenEnvio] = useState("");
  const [openRecepcionOrdenEnvioDialog, setOpenRecepcionOrdenEnvioDialog] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Orden Envío",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "codigo_gc",
      headerName: "Código GC",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "tipo_anteojo_arreglo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return params.row.tipo_anteojo_arreglo === "anteojo" ? "ANTEOJO" : "ARREGLO";
      },
    },
    {
      field: "codigo_gc_anteojo_arreglo",
      headerName: "Código Ant/Arr",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        return params.row.nombre_cliente + " " + params.row.apellido_cliente;
      },
    },
    {
      field: "descripcion_corta_area_genera",
      headerName: "Suc genera",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "descripcion_corta_area_envia",
      headerName: "Suc envía",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "estado",
      headerName: "Estado actual",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        switch (_val) {
          case "preparando":
            _val = "PREPARANDO";
            break;
          case "enviado":
            _val = "POR RECIBIR";
            break;
          case "recibido":
            _val = "RECIBIDA";
            break;
        }
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha de Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "usuario",
      headerName: "Vendedor",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const index = ordenesEnvio.findIndex(item => item.id === params.row.id);
        return (
          <>
            {params.row.action_ver === true && (
              <Tooltip title="Acciones de la Orden de Envío">
                <IconButton
                  size="small"
                  aria-label="view"
                  onClick={() => {
                    if (index !== -1) {
                      handleClickOrdenEnvioDetalles(index);
                    }
                  }}
                >
                  <RemoveRedEyeOutlinedIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    ////loading: isDoingSomething,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadAreas();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.interno_externo === "interno" && area.actividad === "punto-de-venta");
      setAreas(_response);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      codigoOrdenEnvio: searchData.codigoOrdenEnvio,
      codigoGestionAtencion: searchData.codigoGestionAtencion,
      sucursalGenera: searchData.sucursalGenera,
      sucursalEnvia: searchData.sucursalEnvia,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      fechaEstadoDesde: searchData.fechaEstadoDesde,
      fechaEstadoHasta: searchData.fechaEstadoHasta,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getOrdenesEnvio(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setOrdenesEnvio(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickOrdenEnvioDetalles = (parDataIndex) => {
    setIdOrdenEnvio(ordenesEnvio[parDataIndex].id);
    setOpenRecepcionOrdenEnvioDialog(true);
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaEstadoDesde = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaEstadoDesde: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaEstadoHasta = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaEstadoHasta: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setCurrentPage(0);
    setSearchData(initialSearchData);
    setTotalRowsCount(0);
    setOrdenesEnvio([]);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const handleRecibe = () => {
    setOpenRecepcionOrdenEnvioDialog(false);
    load();
  };
  //
  // ################################################################################
  //
  const handleCloseRecepcionOrdenEnvioDialog = () => {
    setOpenRecepcionOrdenEnvioDialog(false);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="sucursal-genera-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                      },
                    }}
                  >
                    Sucursal que genera
                  </InputLabel>
                  <Select
                    labelId="sucursal-genera-select-label"
                    id="sucursal-genera-select"
                    name="sucursalGenera"
                    value={searchData.sucursalGenera}
                    label="Sucursal que genera"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {areas.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="sucursal-envia-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                      },
                    }}
                  >
                    Sucursal que envía
                  </InputLabel>
                  <Select
                    labelId="area-envia-select-label"
                    id="area-envia-select"
                    name="sucursalEnvia"
                    value={searchData.sucursalEnvia}
                    label="Sucursal que envía"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {areas.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoOrdenEnvio"
                  label="Código de Orden de Envío"
                  variant="outlined"
                  size="small"
                  name="codigoOrdenEnvio"
                  value={searchData.codigoOrdenEnvio}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoGestionAtencion"
                  label="Código de Gestión de Atención"
                  variant="outlined"
                  size="small"
                  name="codigoGestionAtencion"
                  value={searchData.codigoGestionAtencion}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionDesde"
                  label="Desde fecha de generación"
                  variant="outlined"
                  name="fechaCreacionDesde"
                  value={searchData.fechaCreacionDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaCreacionDesde) =>
                    handleChangeFechaCreacionDesde(fechaCreacionDesde)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionHasta"
                  label="Hasta fecha de generación"
                  variant="outlined"
                  name="fechaCreacionHasta"
                  value={searchData.fechaCreacionHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaCreacionHasta) =>
                    handleChangeFechaCreacionHasta(fechaCreacionHasta)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="estado-actual-select-label">Estado actual</InputLabel>
                  <Select
                    labelId="estado-actual-select-label"
                    id="estado-actual-select"
                    name="estadoActual"
                    value={searchData.estadoActual}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaEstadoDesde"
                  label="Desde fecha de estado"
                  variant="outlined"
                  name="fechaEstadoDesde"
                  value={searchData.fechaEstadoDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaEstadoDesde) => handleChangeFechaEstadoDesde(fechaEstadoDesde)}
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaEstadoHasta"
                  label="Hasta fecha de estado"
                  variant="outlined"
                  name="fechaEstadoHasta"
                  value={searchData.fechaEstadoHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaEstadoHasta) => handleChangeFechaEstadoHasta(fechaEstadoHasta)}
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={ordenesEnvio}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openRecepcionOrdenEnvioDialog && (
        <RecepcionOrdenEnvioDialog
          idOrdenEnvio={idOrdenEnvio}
          onRecibeParaProduccion={handleRecibe}
          onClose={handleCloseRecepcionOrdenEnvioDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default RecepcionOrdenEnvioTable;
